module.exports = __webpack_public_path__ + "static/services-4-cebcae6081c83cbdd96d00ce5f1a0b2c.jpg";